import { Divider, Stack, Typography } from '@mui/material'

import { useTexts } from '../../../../useTexts'

import { Username } from './components/Username'
import { Password } from './components/Password'
import { Database } from './components/Database'
import { Label } from './components/Label'

export function Geotab() {
  const texts = useTexts()

  return (
    <Stack spacing={2} width="100%">
      <Label />

      <Divider />

      <Typography variant="caption">{texts.geotab.instructions}</Typography>

      <Username />
      <Password />
      <Database />
    </Stack>
  )
}
